<script setup>
import {useConfigStore} from '@core/stores/config'
import {AppContentLayoutNav} from '@layouts/enums'
import {switchToVerticalNavOnLtOverlayNavBreakpoint} from '@layouts/utils'
import CameraTranslateDialog from "@/components/dialogs/CameraTranslateDialog.vue";

const DefaultLayoutWithHorizontalNav = defineAsyncComponent(() => import('./components/DefaultLayoutWithHorizontalNav.vue'))
const DefaultLayoutWithVerticalNav = defineAsyncComponent(() => import('./components/DefaultLayoutWithVerticalNav.vue'))

const configStore = useConfigStore()

switchToVerticalNavOnLtOverlayNavBreakpoint()

const {layoutAttrs, injectSkinClasses} = useSkins()

injectSkinClasses()

const toastRef = ref()

provide('toast', {
  error: msg => toastRef.value?.triggerToast(msg, 'error'),
  success: msg => toastRef.value?.triggerToast(msg, 'success'),
  warning: msg => toastRef.value?.triggerToast(msg, 'warning'),
})

const dialog = reactive({
  show: false
})
provide('camera-translate', dialog)

const loading = ref(true)

onMounted(() => {
  loading.value = false
})
</script>

<template>
  <Component
    v-show="!loading"
    v-bind="layoutAttrs"
    :is="configStore.appContentLayoutNav === AppContentLayoutNav.Vertical ? DefaultLayoutWithVerticalNav : DefaultLayoutWithHorizontalNav"
  >
    <slot/>
  </Component>
  <LoaddingScreen v-show="loading"/>
  <AppToast ref="toastRef"/>
  <CameraTranslateDialog/>
</template>

<style lang="scss">
@use "@layouts/styles/default-layout";
</style>
